import {useSelector} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';

import {useDebounceValue} from 'hooks/useDebounce';

import {getFormattedAddress} from '../../store/selectors/shippingAddress/shippingAddress';

/**
 * Hook which send analytic when checkbox appears in view
 */
export const useProcessEmail = () => {
    const {email: customerEmail, is_logged_in: isLoggedIn} = useGetCustomerData();
    const {sideReviewEmail} = useSelector((store: ApplicationStoreType) => ({
        sideReviewEmail: getFormattedAddress(store).email,
    }));
    const emailTemp = isLoggedIn ? (customerEmail as string) : sideReviewEmail;

    return useDebounceValue(emailTemp, 2000);
};
